import {
  Avatar,
  Box,
  Button,
  IconButton,
  Rating,
  Typography
} from '@mui/material';
import { CreateNewPostCss, ManageReviewsCss } from './localSeoCss';
import { manageReviewsTexts } from './localSeoTexts';
import { SettingModalCss } from '../keywordResearch/keywordTracking/KeywordTrackingAllCss';
import { viewScanDialogSx } from 'src/common/ViewScanDialogSxs';
import CloseIcon from '@mui/icons-material/Close';
import { getTimeAgo } from 'src/common/config/FunctionHelperPartTwo';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { widgetPreviewSx as S } from './EmbedGoogleReviewsComponents/style';
import VerifiedIcon from '@mui/icons-material/Verified';
interface ViewReviewModalProps {
  handleCloseViewModal: () => void;
  row: any;
  getStarRatingValue: (rating: number) => React.ReactNode;
  userDetails?: any;
  isWidget?: boolean | null;
  options?: {
    accentColor?: string;
    font?: string;
    bgColor?: string;
    cardBgColor?: string;
    textColor?: string;
    starsColor?: string;
  } | null;
  locationName?: any;
}

export const ViewReviewModal = ({
  handleCloseViewModal,
  row,
  getStarRatingValue,
  isWidget = null,
  options = null,
  locationName = ''
}: ViewReviewModalProps) => {
  const reviewList =
    useSelector((state: RootState) => state.localSeo.reviewList) ?? null;
  const normalizeReviewData = (row: any, isWidget: boolean | null) => {
    if (!row) return null;

    if (isWidget) {
      // widget structure → transform to match API shape
      return {
        reviewer: {
          displayName: row?.name || '',
          profilePhotoUrl: row?.image || ''
        },
        starRating: row?.stars,
        comment: row?.text || '',
        updateTime: row?.timestamp
          ? new Date(row.timestamp * 1000).toISOString()
          : '',
        // Widgets don’t have reply info
        reviewReply: row?.reviewReplyComment
          ? {
              comment: row?.reviewReplyComment,
              updateTime: row?.reviewReplyDate || ''
            }
          : null
      };
    }

    // API structure already matches expected shape
    return row;
  };
  const normalizedRow = normalizeReviewData(row, isWidget);

  return (
    <Box sx={ManageReviewsCss.replyModalBox(isWidget, options)}>
      <Box sx={SettingModalCss?.titleBoxSx}>
        {' '}
        <Typography
          sx={{
            textAlign: 'left !important',
            ...ManageReviewsCss?.deleteMultipleKeywordTitle(isWidget, options)
          }}
        >
          {' '}
          {isWidget ? '' : manageReviewsTexts?.viewReviewText}{' '}
        </Typography>{' '}
        <IconButton
          style={{ marginTop: '-12px', ...viewScanDialogSx?.closeIconBtnSx }}
          onClick={handleCloseViewModal}
        >
          {' '}
          <CloseIcon sx={{ color: 'var(--color-text-sidebar-icon)' }} />{' '}
        </IconButton>{' '}
      </Box>
      <Box sx={ManageReviewsCss.replyModalDetailsBox}>
        <Box
          className="review-card-bottom"
          display="flex"
          gap="12px"
          alignItems="center"
          sx={{ marginTop: isWidget ? '-42px' : '0px' }}
        >
          <Avatar
            className="review-card-avatar"
            src={!isWidget ? row?.reviewer?.profilePhotoUrl : row?.image}
            alt={row.name}
            sx={S.avatar}
          />
          <Box className="review-card-reviewer" sx={S.reviewerDetails}>
            <Box display={'flex'} alignItems={'center'} gap={'4px'}>
              <Typography
                className="review-card-reviewer-name"
                fontFamily={options?.font}
                sx={S.reviewerName('var(--color-near-black-grey)', options?.font)}
              >
                {isWidget
                  ? row.name
                  : normalizedRow?.reviewer?.displayName || ''}
              </Typography>
              {!row?.isAnonymous && (
                <VerifiedIcon sx={{ color: 'var(--color-primary)', fontSize: 'var(--font-size-14)', }} />
              )}
            </Box>

            <Typography
              className="review-card-time"
              sx={S.reviewTime('rgba(32, 33, 36, 0.7)', options?.font)}
            >
              {isWidget
                ? row.time
                : getTimeAgo(normalizedRow?.updateTime) || ''}
            </Typography>
          </Box>
        </Box>

        {/* Rating + Time */}
        <Box
          sx={{
            marginTop: '16px',
            ...ManageReviewsCss.replyRatingBoxSx
          }}
        >
          <Rating
            name="half-rating"
            precision={1}
            value={
              isWidget
                ? normalizedRow?.starRating
                : getStarRatingValue(normalizedRow?.starRating) || 0
            }
            readOnly
            sx={{
              '& .MuiRating-iconFilled': {
                color: isWidget ? options?.starsColor || 'var(--color-warning-yellow)' : 'var(--color-warning-yellow)'
              }
            }}
          />
        </Box>

        {/* Review text */}
        <Typography sx={ManageReviewsCss.replyTextsSx(isWidget, options)}>
          {normalizedRow?.comment || ''}
        </Typography>

        {/* Reply */}
        {normalizedRow?.reviewReply?.comment && (
          <Box sx={ManageReviewsCss.replyWrapper}>
            {/* vertical divider */}
            <Box sx={ManageReviewsCss.replyDivider} />

            {/* reply content wrapper */}
            <Box sx={ManageReviewsCss.replyContentWrapper}>
              <Box sx={ManageReviewsCss.replyHeaderBox}>
                {/* Avatar */}
                <Avatar sx={ManageReviewsCss.replyAvatar}>
                  {(isWidget ? locationName : reviewList?.locationName || '')
                    ?.charAt(0)
                    ?.toUpperCase()}
                </Avatar>
                {/* Right side content */}
                <Box>
                  <Box sx={ManageReviewsCss.replyNameRow}>
                    <Box>
                      <Typography
                        sx={ManageReviewsCss.replyName(isWidget, options)}
                      >
                        {isWidget
                          ? locationName
                          : reviewList?.locationName || ''}
                      </Typography>
                      <Typography
                        sx={S.reviewTime(
                          'rgba(32, 33, 36, 0.7)',
                          options?.font
                        )}
                      >
                        {getTimeAgo(normalizedRow?.reviewReply?.updateTime) ||
                          ''}
                      </Typography>
                    </Box>
                    <Box sx={ManageReviewsCss.replyBadge}>Owner reply</Box>
                  </Box>
                </Box>
              </Box>

              {/* Reply text */}
              <Typography
                sx={ManageReviewsCss.ownerReplyTextsSx(isWidget, options)}
              >
                {normalizedRow?.reviewReply?.comment || ''}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
      {!isWidget && (
        <Box sx={CreateNewPostCss?.deleteModalBtnBox}>
          <Button
            variant="outlined"
            onClick={handleCloseViewModal}
            sx={ManageReviewsCss.rowBtnSx(isWidget, options)}
          >
            {manageReviewsTexts?.close}
          </Button>
        </Box>
      )}
    </Box>
  );
};
